"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.LayoutNotificationContext = react_1.default.createContext({
    addNotification: function () { return ''; },
    removeNotification: function () { return undefined; },
    removeAllNotifications: function () { return undefined; }
});
//# sourceMappingURL=LayoutNotificationContext.js.map